import { useState } from "react";
import { faqs } from "../data";
import SectionHeader from "./SectionHeader";

const schema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100/70">
      <div
        className="hidden"
        dangerouslySetInnerHTML={{
          __html: `<script type="application/ld+json">${JSON.stringify(schema).replace(/</g, "\\u003c")}</script>`,
        }}
      />
      <div className="site-container py-12 md:py-16">
        <SectionHeader
          eyebrow="常见问题"
          eyebrowIcon="ri-questionnaire-line"
          title="关于塌房预警，你可能想问的"
          desc="把大家最常纠结的几个问题一次讲清楚。若你还有别的疑问，欢迎在文末通过邮箱与我们交流。"
        />

        <div className="mx-auto max-w-3xl space-y-3">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.q}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <h3 className="m-0">
                  <button
                    type="button"
                    aria-expanded={open}
                    onClick={() => setOpenIdx(open ? null : i)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="flex items-center gap-3 text-sm md:text-base font-semibold text-foreground-950">
                      <span className="flex items-center justify-center w-7 h-7 rounded-md bg-primary-100 text-primary-700 shrink-0">
                        <i className="ri-question-line text-sm w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
                      </span>
                      {f.q}
                    </span>
                    <i
                      className={`ri-add-line text-lg text-foreground-500 transition-transform duration-300 w-5 h-5 flex items-center justify-center shrink-0 ${
                        open ? "rotate-45" : ""
                      }`}
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>
                <div
                  className={`grid transition-all duration-300 ease-in-out ${
                    open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 pl-[52px] text-sm leading-relaxed text-foreground-600">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}